export const QUERY_STALE_TIMES = {
  adminAnalytics: 60 * 1000,
  default: 120 * 1000,
  session: 5 * 60 * 1000,
  trending: 5 * 60 * 1000,
  feed: 45 * 1000,
  profile: Infinity,
  dealOffers: 60 * 1000,
  marketplaceListings: Infinity,
  listingCounts: Infinity,
  listMembership: 60 * 1000,
  unreadCount: 5 * 60 * 1000,
} as const;

export const QUERY_GC_TIMES = {
  listMembership: 30 * 60 * 1000,
} as const;

export const QUERY_REFETCH_INTERVALS = {
  adminAgents: 5 * 1000,
  adminOfferClickStream: 60 * 1000,
  listMembership: 60 * 1000,
} as const;

export const QUERY_IDLE_TIMEOUT_MS = 5 * 60 * 1000;

export const QUERY_RETRY_POLICY = {
  attempts: 2,
  baseDelayMs: 1000,
  maxDelayMs: 30 * 1000,
} as const;

export function getRetryDelay(attemptIndex: number) {
  return Math.min(
    QUERY_RETRY_POLICY.baseDelayMs * 2 ** attemptIndex,
    QUERY_RETRY_POLICY.maxDelayMs,
  );
}
